export type ProjectStatus = App.Enums.Project.ProjectStatus

const stateOrder: Record<ProjectStatus, number> = {
  draft: 0,
  'in-clearing': 1,
  live: 2,
  completed: 3,
  cancelled: 4,
}

export const projectStates = Object.keys(stateOrder) as ProjectStatus[]

export const visibleProjectStages: ProjectStatus[] = ['in-clearing', 'live', 'completed']

export const toProjectStatus = (status: ProjectStatus | null | undefined): ProjectStatus => status ?? 'draft'

export const toVisibleProjectStatus = (status: ProjectStatus | null | undefined): ProjectStatus => {
  const current = toProjectStatus(status)

  return current === 'draft' ? 'in-clearing' : current
}
